"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _ScalewayObjectStorage = /*#__PURE__*/ _interop_require_default(require("./ScalewayObjectStorage"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ScalewayObjectStoragePlugin = class ScalewayObjectStoragePlugin extends _ncplugin.XcStoragePlugin {
    async init(config) {
        ScalewayObjectStoragePlugin.storageAdapter = new _ScalewayObjectStorage.default(config);
        await ScalewayObjectStoragePlugin.storageAdapter.init();
    }
    getAdapter() {
        return ScalewayObjectStoragePlugin.storageAdapter;
    }
};
const _default = ScalewayObjectStoragePlugin;
